/*
 * Discover dropdown: scroll progress bar (Willbo-style).
 *
 * The Discover mega-menu's photo tiles (custom-header-v3.css) scroll
 * horizontally with the native scrollbar hidden. This injects a thin
 * progress track + thumb + left/right arrows right after the tile row,
 * keeps the thumb in sync with scroll position, and wires the arrows to
 * scroll by one tile at a time.
 *
 * The tile row is position:fixed (custom-header.css) so it can span the
 * page edge-to-edge like Willbo's Explore panel, instead of being sized to
 * its own tiles and anchored under the "Discover" link (its old positioned
 * ancestor). positionRow() below sets the row's left/width/top in JS on
 * every open/resize/scroll so it always spans the viewport (minus a fixed
 * gutter) directly under the header. The progress bar is fixed too, with
 * its own left/width/top set from the row's live getBoundingClientRect()
 * so it stays flush under the tiles however tall they end up being.
 *
 * Scoped entirely to [data-menu-handle="discover"] - no other dropdown is
 * touched, and nothing here changes shared markup in nav-call-to-action.liquid.
 */
(function () {
  function buildBar() {
    var bar = document.createElement('div');
    bar.className = 'discover-scrollbar';
    bar.innerHTML =
      '<button type="button" class="discover-scrollbar__arrow" data-dir="-1" aria-label="Scroll left">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>' +
      '</button>' +
      '<div class="discover-scrollbar__track"><div class="discover-scrollbar__thumb"></div></div>' +
      '<button type="button" class="discover-scrollbar__arrow" data-dir="1" aria-label="Scroll right">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>' +
      '</button>';
    return bar;
  }

  function setup(row) {
    if (row.dataset.scrollbarInit) return;
    row.dataset.scrollbarInit = '1';

    var bar = buildBar();
    row.insertAdjacentElement('afterend', bar);

    var thumb = bar.querySelector('.discover-scrollbar__thumb');
    var leftBtn = bar.querySelector('[data-dir="-1"]');
    var rightBtn = bar.querySelector('[data-dir="1"]');
    var li = row.closest('li');

    var GUTTER = 24;

    function positionRow() {
      // The row is position:fixed (custom-header.css) so it can span the
      // header's full width edge-to-edge, Willbo-style, instead of being
      // boxed in under the "Discover" link (its old positioned ancestor).
      // Anchor its top to the bottom of the nav item that triggers it, so
      // it still opens directly under the header, but let it span the
      // viewport width horizontally.
      var anchorBottom = li ? li.getBoundingClientRect().bottom : 0;
      row.style.left = GUTTER + 'px';
      row.style.width = (window.innerWidth - GUTTER * 2) + 'px';
      row.style.top = anchorBottom + 'px';
    }

    function reposition() {
      // Bar is fixed too - match the row's own on-screen box exactly so it
      // sits flush under the photos instead of in flow.
      positionRow();
      var rect = row.getBoundingClientRect();
      bar.style.left = rect.left + 'px';
      bar.style.width = rect.width + 'px';
      bar.style.top = rect.bottom + 'px';
    }

    function update() {
      reposition();
      var max = row.scrollWidth - row.clientWidth;
      if (max <= 1) {
        bar.style.display = 'none';
        return;
      }
      bar.style.display = '';
      var ratio = Math.min(row.clientWidth / row.scrollWidth, 1);
      var pos = row.scrollLeft / max;
      thumb.style.width = (ratio * 100) + '%';
      thumb.style.left = (pos * (100 - ratio * 100)) + '%';
      leftBtn.disabled = row.scrollLeft <= 2;
      rightBtn.disabled = row.scrollLeft >= max - 2;
    }

    function scrollByTile(dir) {
      var tile = row.querySelector('.nav-ctas__cta');
      var amount = tile ? tile.getBoundingClientRect().width + 20 : row.clientWidth * 0.8;
      row.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    leftBtn.addEventListener('click', function () { scrollByTile(-1); });
    rightBtn.addEventListener('click', function () { scrollByTile(1); });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // The dropdown panel is hidden (and often width:0) until it opens, so
    // the row's real size/position only exist once the menu item is
    // hovered/focused - recheck right then, not just at page load.
    if (li) {
      li.addEventListener('mouseenter', function () {
        update();
        setTimeout(update, 50);
      });
      li.addEventListener('focusin', update);
    }

    // Images load in lazily, which changes scrollWidth/height - recheck for
    // a beat after load too.
    var tries = 0;
    var poll = setInterval(function () {
      update();
      tries += 1;
      if (tries > 15) clearInterval(poll);
    }, 200);
  }

  function init() {
    var row = document.querySelector('.tier-1 ul[data-menu-handle="discover"]');
    if (row) setup(row);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections on edit - re-run so the bar survives.
  document.addEventListener('shopify:section:load', init);
})();
